<template lang="pug"></template>

<script>
export default {
    name: 'BotaoGestaoOperacoes',
    componentOptions: {
        title: 'Operação',
        actions: [
            [
                {
                    name: 'Gestão',
                    iconClass: 'lyra-icon lyra-gestao',
                    showView: false,
                    action: 'abrirOperacoes',
                    route: 'operacao',
                    nameTranslationKey: 'mensagens.menuLateral.gestao'
                }
            ]
        ]
    },

    methods: {
        abrirOperacoes() {
            if (this.$route.name !== 'operacao') {
                this.$router.push({ name: 'operacao' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
